import { selectDepartments } from "app/containers/AdminConsole/slice";
import { useAppSelector } from "utils/redux/hooks";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "app/shadcnComponents/ui/select";
const ALL_VALUE = "all";

interface Props {
  department: string;
  onDepartmentChange: (value: string) => void;
  status: string;
  onStatusChange: (value: string) => void;
  visibility: string;
  onVisibilityChange: (value: string) => void;
}
export default function FiltersAllGoal({
  department,
  onDepartmentChange,
  status,
  onStatusChange,
  visibility,
  onVisibilityChange,
}: Readonly<Props>) {
  const departments = useAppSelector(selectDepartments);

  return (
    <div className="goals-filters-bar">
      <Select
        value={department || ALL_VALUE}
        onValueChange={(value) =>
          onDepartmentChange(value === ALL_VALUE ? "" : value)
        }
      >
        <SelectTrigger className="filter-select">
          <SelectValue placeholder="All Departments" />
        </SelectTrigger>
        <SelectContent className="max-h-[400px] overflow-y-auto">
          <SelectItem value={ALL_VALUE}>All Departments</SelectItem>
          {Object.values(departments).map((dept) => (
            <SelectItem
              key={dept.departmentId}
              value={dept.departmentId.toString()}
            >
              {dept.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={status || ALL_VALUE}
        onValueChange={(value) =>
          onStatusChange(value === ALL_VALUE ? "" : value)
        }
      >
        <SelectTrigger className="filter-select">
          <SelectValue placeholder="All Statuses" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL_VALUE}>All Statuses</SelectItem>
          <SelectItem value="on_track">On Track</SelectItem>
          <SelectItem value="some_challenges">Some Challenges</SelectItem>
          <SelectItem value="unlikely_to_reach">Unlikely To Reach</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={visibility || ALL_VALUE}
        onValueChange={(value) =>
          onVisibilityChange(value === ALL_VALUE ? "" : value)
        }
      >
        <SelectTrigger className="filter-select">
          <SelectValue placeholder="All Visibility" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL_VALUE}>All Visibility</SelectItem>
          <SelectItem value="standard">Standard</SelectItem>
          <SelectItem value="shared">Shared</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
